import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import {
  BatchSpanProcessor,
} from '@opentelemetry/sdk-trace-base';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { W3CTextMapPropagator } from '../w3ctextMapPropagator';
import { SpanStatusCode, trace } from '@opentelemetry/api';
import { ReactNode } from 'react';
import { getResource } from './resource';
import { Resource } from '@opentelemetry/resources/build/src';
const { ZoneContextManager } = require('@opentelemetry/context-zone');


export var userAttributes: Record<string, any> = {};

export const seOtelLogstUserAttributes = (newAttributes: Record<string, any>) => {
  Object.assign(userAttributes, newAttributes);
};

var provider: WebTracerProvider;

const fetchInstrumentation = new FetchInstrumentation({
  ignoreUrls: [/^(?!.*rupeezy\.in).*/],
  clearTimingResources: true,
  propagateTraceHeaderCorsUrls: [/^https?:\/\/(?!(sst)\.)[\w-]+\.rupeezy\.in(\/|$)/,],
  applyCustomAttributesOnSpan: ((span, request, fetchError) => {
    span = span.setAttributes(userAttributes)
    if (fetchError.status === undefined || fetchError.status > 400) {
      span = span.setStatus({ code: SpanStatusCode.ERROR })
    }
  }),

});

const xmlInstrumentation = new XMLHttpRequestInstrumentation({
  ignoreUrls: [/^(?!.*rupeezy\.in).*/],
  clearTimingResources: true,
  propagateTraceHeaderCorsUrls: [/^https?:\/\/(?:[\w-]+\.)?rupeezy\.in(\/|$)/],
  applyCustomAttributesOnSpan: ((span, request) => {
    span = span.setAttributes(userAttributes)
    if (request.status === undefined || request.status > 400) {
      span = span.setStatus({ code: SpanStatusCode.ERROR })
    }
  }),
});

// export function getProvider(){
//   return provider; 
// }

function registerProvider(provider: WebTracerProvider) {
  provider.register({
    contextManager: new ZoneContextManager(),
    propagator: new W3CTextMapPropagator(),
  });
  return provider;
}

function registerInstrumentation(provider: WebTracerProvider) {
  registerInstrumentations({
    instrumentations: [
      fetchInstrumentation,
      xmlInstrumentation
    ],
    tracerProvider: provider,
  });
}
export function setupTracing() {
  provider = new WebTracerProvider({
    resource: getResource(),
    spanProcessors: [new BatchSpanProcessor(new OTLPTraceExporter(
      {
        url: 'https://tracer.rupeezy.in/v1/traces',
      }
    ), { maxExportBatchSize: 50 })],
  });

  provider = registerProvider(provider);
  registerInstrumentation(provider);
}
interface TraceProviderProps {
  children: ReactNode;
}
export default function TraceProvider({ children }: TraceProviderProps) {

  return (
    <>
      {children}
    </>
  );

}